import plugin from "tailwindcss/plugin.js";
// TODO: remove this mapping logic after migrating to new class names
const fontFaces = [
    ["tiny-700-caps", "xsmall-650"],
    ["xxx-small-500", "xsmall-525"],
    ["xxx-small-700-caps", "xsmall-650"],
    ["xxx-small-800-caps", "xsmall-650"],
    ["xx-small-500", "xsmall-525"],
    ["x-small-400", "small-400"],
    ["x-small-500", "small-525"],
    ["x-small-500-caps", "small-525"],
    ["x-small-600", "small-650"],
    ["x-small-600-caps", "small-650"],
    ["small-500", "medium-525"],
    ["small-600", "medium-650"],
    ["small-600-caps", "medium-650"],
    ["small-700", "medium-650"],
    ["medium-500", "large-525"],
    ["medium-600", "large-650"],
    ["large-500", "large-525"],
    ["large-600-caps", "large-650"],
    ["x-large-400", "xlarge-400"],
    ["x-large-500", "xlarge-525"],
    ["x-large-600", "xlarge-650"],
    ["x-large-700", "xlarge-650"],
    ["xx-large-600-caps", "4xlarge-650"],
    ["xx-large-600", "4xlarge-650"],
    "xsmall-400",
    "xsmall-525",
    "xsmall-650",
    "small-400",
    "small-525",
    "small-650",
    "medium-400",
    "medium-525",
    "medium-650",
    "large-400",
    "large-525",
    "large-650",
    "xlarge-400",
    "xlarge-525",
    "xlarge-650",
    "2xlarge-400",
    "2xlarge-525",
    "2xlarge-650",
    "3xlarge-400",
    "3xlarge-525",
    "3xlarge-650",
    "4xlarge-400",
    "4xlarge-525",
    "4xlarge-650",
];
const STATIC_FONT_FACES = {
    ".font-inherit": {
        fontSize: "inherit",
        textDecoration: "inherit",
        fontFamily: "inherit",
        fontWeight: "inherit",
        fontStyle: "inherit",
        fontStretch: "inherit",
        letterSpacing: "inherit",
        textTransform: "inherit",
    },
};
export default plugin(({ addUtilities }) => {
    addUtilities(fontFaces.reduce((aggregate, arg) => {
        // TODO: revert this logic after migrating to new classes
        const [from, to] = Array.isArray(arg) ? arg : [arg, arg];
        return {
            ...aggregate,
            [`.font-${from}`]: {
                fontSize: `var(--typography-v2-${to}-font-size)`,
                textDecoration: `var(--typography-v2-${to}-text-decoration)`,
                fontFamily: `var(--typography-v2-${to}-font-family)`,
                // TODO: for now, setting all font-weights to 400. After design has had time to review and determine
                // where we should have higher weights, we will update this logic and update related classes | mattnicolay20250131
                fontWeight: 400,
                fontStyle: `var(--typography-v2-${to}-font-style)`,
                fontStretch: `var(--typography-v2-${to}-font-stretch)`,
                letterSpacing: `var(--typography-v2-${to}-letter-spacing)`,
            },
        };
    }, STATIC_FONT_FACES));
});
